import img_loading from "assets/img/loading.svg";
import img_unlock from "assets/img/unlock.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useState } from "react";
import { queryOpenAccessToApplications } from "service/api";

export const MenuItemButtonOpenAccessToApplication = ({ applicationId }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const handleClick = async () => {
    try {
      setIsPending(true);
      await queryOpenAccessToApplications({ applicationId });
      setHasAccess(true);
    } catch (error: any) {
      alert(error.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <MenuItemButton
      onClick={handleClick}
      disabled={hasAccess}
      title={
        !isPending
          ? hasAccess
            ? `Доступ открыт`
            : `Открыть доступ`
          : "Загрузка..."
      }
      iconSrc={!isPending ? img_unlock : img_loading}
    />
  );
};
